for (let i = 0; i < document.getElementsByClassName('side_images').length; i++) {
    document.getElementsByClassName('side_images')[i].addEventListener('click', function () {

        const clicked = document.getElementsByClassName('side_images')[i];

        const displayed = document.querySelector('.displayed_img');

        const temp = displayed.src;
        displayed.src = clicked.src;
        clicked.src = temp;
    });
}